import { render } from "./SendingOverlay.vue?vue&type=template&id=0e25cd96&scoped=true"
import script from "./SendingOverlay.vue?vue&type=script&lang=js"
export * from "./SendingOverlay.vue?vue&type=script&lang=js"

import "./SendingOverlay.vue?vue&type=style&index=0&id=0e25cd96&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e25cd96"]])

export default __exports__